import React from "react";
import { managerAxios } from "../../axiosInstance";
import * as XLSX from "xlsx";

function ExportProductList() {
  const handleDownload = async () => {
    try {
      const response = await managerAxios.post("products/export");

      const filteredData = response?.data?.data?.map((item, index) => ({
        // "Image":,
        NO: index + 1,
        "Product Name": item?.product_name,
        Stock: item?.available_quantity,
        Price: item?.price,
        Category: item?.category?.cat_name,
      }));

      const ws = XLSX.utils.json_to_sheet(filteredData);
      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, "Sheet1");
      XLSX.writeFile(wb, "products.xlsx");
    } catch (err) {
      console.log("Error fetching data", err);
    } finally {
      //   setIsLoading(false);
      // setIsNextLoading(false);
      // setIsPrevLoading(false);
    }
  };
  return (
    <button
      onClick={() => handleDownload()}
      className="px-4 py-3 text-white rounded-lg bg-green-500"
    >
      Export Product List
    </button>
  );
}

export default ExportProductList;
